import { useDomainState } from "../../state/editor/useEditor";
import type { ChromeInsets } from "./layout";

/*
 * The floating "New here? 1 … 2 … 3 …" banner that used to live here is gone
 * (2026-09-29): it sat over the ring in 11px grey. First-run help is now the
 * numbered steps on the rail and the three-step card at the top of Looks, both
 * dismissed by one "Got it" (`ui.coachDone`).
 */

/**
 * Canvas HUD — which part is selected. (Not its material label: that is the
 * viewer's internal id for what it assigned, e.g. "whiteGold polished".)
 *
 * The Canvas chrome also carried a POSE badge. It is deliberately not ported:
 * docs/INERT-CONTROL-TRIAGE.md already recorded it as going stale the moment
 * anyone orbits by hand, because there is no camera-moved event to correct it.
 * A badge that lies about where the camera is, is worse than no badge.
 */
export function StudioHud({ insets }: { insets: ChromeInsets }) {
  const groups = useDomainState("groups");
  const selection = useDomainState("selection");
  const part = groups.find((g) => g.id === selection);
  if (!part) return null;
  const chip = "rounded-full bg-ed-panel/95 px-2.5 py-1 text-[12px] font-medium text-ed-text shadow-[0_2px_8px_rgba(0,0,0,0.08)] backdrop-blur-sm";
  return (
    <div className="pointer-events-none absolute bottom-[30px] z-[7] flex flex-wrap gap-1.5" style={{ left: insets.left + 26 }} data-studio-hud>
      <span className={chip}>{part.label}</span>
    </div>
  );
}
